import React from 'react';

import { Box, Spacer } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';
import { Atm, Mbway } from '@icons';

export const AtmAndMbway: React.FC = () => {
	return (
		<Box>
			<Atm />
			<Spacer horizontal={rem(48)} />
			<Mbway />
		</Box>
	);
};
